module.exports = __webpack_public_path__ + "static/media/logo_harionaelizondo.a55e7892.jpg";